/**
 * media_signal igniter anomaly styling (#184, migration 0072 — operator-cop-
 * doctrine §3B.8, design-council §3A.7 context-locked palette).
 *
 * COLOUR-LAW DISPOSITION (PART I + Law 2, resolved by precedent — the smoke
 * register): a chatter spike is LOW-CONFIDENCE and UNSCORED, so it does NOT
 * take URGENT-RED or the pulse (Law 2 reserves #ff3b30 + motion for
 * unacknowledged urgent anomalies; the founder's 2026-06-05 motion-budget
 * revision keeps pending/needs-assessment items static). It joins the register
 * smoke_detected established — "needs operator eyes, not yet a scored anomaly":
 * a distinct static hue + an explicit pending badge, ranked in the queue BELOW
 * every scored Response Level (rank 1.5 — see anomalyQueue.ts). Colour is never
 * load-bearing alone: the hue is always paired with the badge label.
 *
 * SKY ("wire blue") — distinct from smoke's amber #f59e0b, the anomaly red,
 * outage bronze, comms indigo, evac violet, marine's desaturated cyan-slate.
 */

/** Sky — "needs assessment", the media/wire family hue. Static, never pulses. */
export const MEDIA_SIGNAL_ANOMALY_COLOR = '#38bdf8';

/** The non-Response-Level badge shown in the queue row + detail panel. */
export const MEDIA_SIGNAL_PENDING_BADGE_LABEL = 'Needs assessment — unverified media chatter';

/** Short queue-chip variant of the badge. */
export const MEDIA_SIGNAL_CHIP_LABEL = 'needs assessment';

/** Operator-facing hazard wording for the two v1 igniter scopes. */
export function mediaSignalHazardLabel(hazardKey: string): string {
  switch (hazardKey) {
    case 'power_outage':
      return 'Power outage chatter';
    case 'civil_disturbance':
      return 'Civil disturbance chatter';
    default:
      return 'Hazard chatter';
  }
}
